/* Boucle infinie pour le carrousel "Nos cuvées" — scopé à .product-carousel
   pour ne pas affecter les autres sliders du thème (méga-menu, diaporama).
   Écoute les clics en phase de capture (avant le gestionnaire natif de
   slider-component dans global.js) : si on est déjà au bord, on intercepte
   le clic et on renvoie au bord opposé au lieu de laisser le clic natif se
   faire clamper sans effet. Sinon on laisse le comportement normal du
   thème gérer le défilement. */
class ProductCarouselLoop {
  constructor(root) {
    this.slider = root.querySelector('[id^="Slider-"]');
    this.prevButton = root.querySelector('button[name="previous"]');
    this.nextButton = root.querySelector('button[name="next"]');

    if (!this.slider || !this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', this.onPrev.bind(this), true);
    this.nextButton.addEventListener('click', this.onNext.bind(this), true);

    // slider-component (global.js) désactive prev/next via l'attribut
    // disabled aux bords (un bouton disabled ne déclenche plus de clic
    // du tout) — on l'annule en continu pour que la boucle reste cliquable.
    this.keepButtonsEnabled();
  }

  keepButtonsEnabled() {
    [this.prevButton, this.nextButton].forEach((button) => {
      const observer = new MutationObserver(() => {
        if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
      });
      observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
    });
  }

  atStart() {
    return this.slider.scrollLeft <= 1;
  }

  atEnd() {
    return this.slider.scrollLeft >= this.slider.scrollWidth - this.slider.clientWidth - 1;
  }

  onPrev(event) {
    if (!this.atStart()) return;
    event.preventDefault();
    event.stopPropagation();
    this.slider.scrollTo({ left: this.slider.scrollWidth, behavior: 'smooth' });
  }

  onNext(event) {
    if (!this.atEnd()) return;
    event.preventDefault();
    event.stopPropagation();
    this.slider.scrollTo({ left: 0, behavior: 'smooth' });
  }
}

document.querySelectorAll('.product-carousel').forEach((root) => new ProductCarouselLoop(root));
